var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('v-img',{attrs:{"src":_vm.image,"contain":""},on:{"click":function($event){return _vm.getUrl(_vm.imageUrl)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }